<template>
  <div class="page-register">
    <div class="background"></div>
    <el-card id="wrap_box_card">
      <p class="page-title">{{ $t('login.manageSystem') }}</p>
      <el-card class="box-card" :body-style="{ padding: '0px' }">
        <el-col :span="24" class="input-row">
          <el-row class="img-row">
            <el-image :src="logo" fit="contain"></el-image>

          </el-row>

          <el-row>
            <el-form ref="form" @submit.native.prevent="handleRegister">
              <el-input v-model="loginName" required :placeholder="$t('login.inputEmail')" autocomplete="off"></el-input>

              <div style="margin: 10px 0;"></div>
              <el-row>
                <el-input v-model="rucaptcha" required :placeholder="$t('login.inputRucaptcha')" autocomplete="off" style="width:140px"></el-input>
                <el-link href="javascript:;" @click.native="refreshCaptchaSrc" class="captcha-img-wrapper" v-if="captchaSrc">
                  <img :src="captchaSrc" />
                </el-link>
              </el-row>

              <div style="margin: 10px 0;"></div>
              <el-row>
                <el-input v-model="verificationCode" required :placeholder="$t('login.inputVerificationCode')" autocomplete="off" style="width:140px"></el-input>
                <el-button type="primary" style="width:100px;marginLeft:10px" @click.native="sendVerificationCode" :disabled="disableSendVerificationCode">
                  <span v-show="!displayCountdown">{{$t('login.sendVerificationCode')}}</span>
                  <span v-show="displayCountdown">{{count}}s</span>
                </el-button>
              </el-row>

              <div style="margin: 10px 0;"></div>
              <el-input
                v-model="password"
                required
                :type="password"
                show-password
                :placeholder="$t('login.setPassword')"
                autocomplete="off"
              ></el-input>

              <div style="margin: 10px 0;"></div>
              <el-row justify="center" size="medium">
                <el-button type="primary" native-type="submit" class="submit-btn">{{$t('login.resetPassword')}}</el-button>
              </el-row>

              <el-row justify="center" size="medium" style="margin: 10px 0;">
                <router-link :to="'login'">{{$t('login.signIn')}}</router-link>
              </el-row>
            </el-form>
          </el-row>
        </el-col>
      </el-card>
    </el-card>
  </div>
</template>

<script>
  import { Vue, Component } from 'vue-property-decorator';
  import Sidebar from '../login/welcome';

  @Component({ components: { Sidebar } })
  export default class Password extends Vue {
    loginName = '';
    password = '';
    rucaptcha = '';
    verificationCode = '';
    logo = require('@/assets/logo.png')
    count = 60;
    displayCountdown = false
    timer = null
    captchaSrc = null;

    refreshCaptchaSrc() {
      this.captchaSrc = `/admin_api/v1/captcha?timestamp=${(new Date()).getTime()}`;
      this.rucaptcha = '';
    }

    mounted() {
      this.refreshCaptchaSrc();
    }

    get disableSendVerificationCode() {
      return this.displayCountdown || this.loginName === '' || this.rucaptcha === ''
    }

    async handleRegister() {
      await this.$autoLoading(
        this.$request.put('/passwords', {
          login_name: this.loginName,
          verification_code: this.verificationCode,
          password: this.password
        })
      );
      this.$message.success(this.$t('login.resetPasswordSuccess'));
      this.$router.replace({ name: 'login' });
    }

    async sendVerificationCode() {
      const countNum = 60;

      try {
        await this.$autoLoading(
          this.$request.post('/verification_codes', {
            target: this.loginName,
            event: 'reset_password',
            rucaptcha: this.rucaptcha
          })
        );

        this.$message.success('验证码已发送');

        this.displayCountdown = true
        this.count = countNum
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= countNum) {
            this.count--;
          } else {
            this.refreshCaptchaSrc()
            this.displayCountdown = false;
            clearInterval(this.timer);  // 清除定时器
            this.timer = null;
          }
        }, 1000)
      } catch (err) {
        if (err.status === 400) {
          this.refreshCaptchaSrc()
        }
      }
    }
  }
</script>

<style lang="scss">
.page-register {
  width: 100%;
  height: 100%;
  background-color: $primary;
  svg linearGradient stop {
    stop-color: #17E890;
  }
  .background-color {
    fill: #17E890;
  }
  .background {
    top: 50%;
    left: 50%;
    overflow: hidden;
    position: absolute;
    transform: translate(-50%, -50%);
  }
  #wrap_box_card {
    top: 48%;
    left: 50%;
    width: 400px;
    position: absolute;
    text-align: center;
    box-shadow: none;
    border-style: none;
    outline-color: transparent;
    -webkit-box-shadow: none;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    background-color: rgba(255, 255, 255, 0.0);
    .page-title {
      color: #ffffff;
      font-size: 20px;
    }
    .box-card {
      border-style: none;
      .img-row {
        font-size: 24px;
        margin: 15px 0 5px;
        font-weight: bold;

        img {
          width: 135px;
        }
      }
      .submit-btn {
        width: 250px;
        height: 44px;
        border: none;
        font-size: 15px;
      }

      .el-form-item__content {
        text-align: left;
      }

      .el-input {
        width: 250px;
      }
    }
  }

  a.captcha-img-wrapper:hover:after {
    border-bottom: initial;
  }

  .captcha-img-wrapper {
    img {
      width: 100px;
      height: 35px;
      margin-left: 10px
    }
  }
}
</style>
